import { HttpEventType } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppleApplicationsService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import { NoActions } from '../no.actions';
import {
  AppleApplicationApiActions,
  AppleApplicationResolverActions,
  AppleApplicationViewActions,
} from './apple-applications.actions';
import { UploadService } from './upload.service';
@Injectable()
export class AppleApplicationEffects {
  private readonly actions$ = inject(Actions);
  private readonly api = inject(AppleApplicationsService);
  private readonly uploadApi = inject(UploadService);

  loadAppleApplicationsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppleApplicationResolverActions.applicationsRequested),
      mergeMap(() =>
        safeMap(
          this.api.getApplications({ apiVersion: '2.0' }),
          (applications) => AppleApplicationApiActions.applicationsLoaded({ applications }),
          (error) => AppleApplicationApiActions.applicationsLoadedError({ error })
        )
      )
    );
  });

  addAppleApplicationEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppleApplicationViewActions.applicationAdded),
      mergeMap(({ application }) =>
        safeMap(
          this.uploadApi.addApplicationForm(application, '2.0', 'events', true),
          (event) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                return AppleApplicationApiActions.applicationUploadProgressed({
                  progress: Math.round((event.loaded / (event.total ?? 1)) * 100),
                });
              case HttpEventType.Response:
                if (!event.body) return NoActions.noAction();
                return AppleApplicationApiActions.applicationAdded({ application: event.body });
              default:
                return NoActions.noAction(); // Make sure that other types don't dispatch an undefined action
            }
          },
          (error) => AppleApplicationApiActions.applicationAddedError({ error })
        )
      )
    );
  });

  deleteAppleApplicationEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppleApplicationViewActions.applicationDeleted),
      mergeMap(({ bundleIdentifier, version }) =>
        safeMap(
          this.api.deleteApplication({ bundleIdentifier, apiVersion: '2.0', bundleVersion: version }),
          () => AppleApplicationApiActions.applicationDeleted({ bundleIdentifier, version }),
          (error) => AppleApplicationApiActions.applicationDeletedError({ error })
        )
      )
    );
  });
}
